'use strict';
trialBalanceController.$inject = [
	'$scope',
	'$rootScope',
	'$q',
	'$interval',
	'dialogHelper',
	'reportHelper',
	'unitService',
	'accountStructureService',
	'USER_CLAIMS',
	'BUSY_MESSAGE',
];
angular.module('schoolLinqApp').controller('trialBalanceController', trialBalanceController);

function trialBalanceController(
	$scope,
	$rootScope,
	$q,
	$interval,
	dialogHelper,
	reportHelper,
	unitService,
	accountStructureService,
	USER_CLAIMS,
	BUSY_MESSAGE
) {
	$scope.reportInterval = null;
	$scope.isReportFinished = false;

	var viewModel = getViewModel();
	$scope.vm = viewModel;

	if ($rootScope.mode && $rootScope.mode === 'nutrition') {
		$scope.vm.isNutrition = true;
		$scope.vm.fundMenuSection = 'NutritionReports';
		$scope.vm.sectiontitle = 'School Nutrition Trial Balance';
	}

	$scope.loadingPromise = $q.all([
		$scope.vm.LoadFiscalYears($scope.vm),
		$scope.vm.LoadFiscalMonths($scope.vm),
		$scope.vm.LoadAccountStructures($scope.vm),
		$scope.vm.LoadFunds($scope.vm),
	]);

	function getViewModel() {
		var model = {
			isNutrition: false,
			fundMenuSection: 'AccountsReports',
			sectiontitle: 'Trial Balance',
			message: BUSY_MESSAGE.Loading,
			fiscalMonths: [],
			fiscalYears: [],
			elements: [],
			fundsCheckAll: true,
			fundsLeft: [],
			fundsMiddle: [],
			fundsRight: [],
			claimSections: USER_CLAIMS,
			unifiedElementMap: null,
			unifiedAccountMask: null,
			filter: {
				fiscalYear: null,
				fiscalMonthFrom: '0',
				fiscalMonthTo: '0',
				thirteenthMonth: false,
				displayBegMonthBalance: false,
				displayFundSummary: false,
				excludeZeroBalanceAccounts: true,
				excludeZeroBalanceAccountsInactive: false,
				sortElement: '-1',
				accountFiltersGrid: null,
				accountFiltersType: null,
				fundsSelected: [],
				reportParameters: [],
			},
			validationErrors: [],
			errors: null,
		};

		function validateReportParams(model) {
			model.validationErrors = [];
			let isValid = true;

			if (!model.filter.fiscalYear) {
				model.validationErrors.push('Please select a Fiscal Year.');
				isValid = false;
			}

			if (model.filter.thirteenthMonth !== true) {
				if (!model.filter.fiscalMonthFrom) {
					model.validationErrors.push("Please select a valid 'From' month.");
					isValid = false;
				}

				if (!model.filter.fiscalMonthTo) {
					model.validationErrors.push("Please select a valid 'To' month.");
					isValid = false;
				}

				let fyStartMonth = parseInt(moment(model.filter.fiscalYear.FYStartDT).format('MM'));
				let dateFrom = null;
				let dateTo = null;

				if (model.filter.fiscalMonthFrom < fyStartMonth) {
					dateFrom = model.filter.fiscalMonthFrom + '/01/' + moment(model.filter.fiscalYear.FYEndDT).format('YYYY');
				} else {
					dateFrom = model.filter.fiscalMonthFrom + '/01/' + moment(model.filter.fiscalYear.FYStartDT).format('YYYY');
				}

				if (model.filter.fiscalMonthTo < fyStartMonth) {
					dateTo = model.filter.fiscalMonthTo + '/01/' + moment(model.filter.fiscalYear.FYEndDT).format('YYYY');
				} else {
					dateTo = model.filter.fiscalMonthTo + '/01/' + moment(model.filter.fiscalYear.FYStartDT).format('YYYY');
				}

				if (isValid === true && moment(dateFrom, 'MM-DD-YYYY').startOf('day') > moment(dateTo, 'MM-DD-YYYY').startOf('day')) {
					model.validationErrors.push('To month must be equal or greater than From month and also be within the Fiscal Year selected.');
					isValid = false;
				}
			}

			var isOneSelected = false;
			var arrFunds = [model.fundsLeft, model.fundsMiddle, model.fundsRight];
			angular.forEach(arrFunds, function (funds) {
				if (isOneSelected === false) {
					isOneSelected = _.some(funds, function (obj) {
						return obj.Selected === true;
					});
				}
			});

			if (isOneSelected === false) {
				model.validationErrors.push('Please select one or more Funds to include in Trial Balance.');
				isValid = false;
			}
			var idx = 0;
			var acctF = null;
			if (model.unifiedElementMap) {
				for (idx = 0; idx < model.filter.accountFiltersGrid.length; idx++) {
					acctF = model.filter.accountFiltersGrid[idx];

					if (acctF.fromValue) {
						if (!acctF.toValue) {
							acctF.toValue = acctF.fromValue;
						}

						if (parseInt(acctF.fromValue) > parseInt(acctF.toValue)) {
							model.validationErrors.push("Element: '" + acctF.element + "' has an invalid range!");
							isValid = false;
						}
					}
				}
			} else {
				for (idx = 0; idx < model.filter.accountFiltersType.length; idx++) {
					acctF = model.filter.accountFiltersType[idx];

					if (!acctF.type) {
						model.validationErrors.push('Please select a valid Account Type!');
						isValid = false;
						break;
					} else {
						if (acctF.queries) {
							for (var qidx = 0; qidx < acctF.queries.length; qidx++) {
								var query = acctF.queries[qidx];

								if (query.AccountTypeId !== 0) {
									if (!query.ElementIndex) {
										model.validationErrors.push('Please select a valid Element for Account Range!');
										isValid = false;
									}
									if (!query.QueryOption) {
										model.validationErrors.push('Please select a range item for Account Range!');
										isValid = false;
									}
									if (!query.Value) {
										model.validationErrors.push('Please enter a value for Account Range!');
										isValid = false;
									}
									if (isValid === false) {
										break;
									}
								}
							}
						}
					}
				}
			}

			return isValid;
		}

		function openReport(model) {
			if (!validateReportParams(model)) {
				dialogHelper.openMessageBox('Trial Balance Report Error!', '', model.validationErrors, 'Warning');
				return false;
			}

			$scope.isReportFinished = false;
			model.message = BUSY_MESSAGE.GeneratingReport;
			$scope.loadingPromise = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			model.filter.reportParameters = [];

			// get selected funds
			model.filter.fundsSelected = [];
			if (model.fundsCheckAll === true) {
				model.filter.fundsSelected.push({ Id: 0, Description: 'All' });
			} else {
				let arrFunds = [model.fundsLeft, model.fundsMiddle, model.fundsRight];
				angular.forEach(arrFunds, function (funds) {
					angular.forEach(funds, function (obj) {
						if (obj.Selected === true) {
							let obj2 = { Id: obj.Id, Description: obj.Description };
							model.filter.fundsSelected.push(obj2);
						}
					});
				});
			}

			// Build Account Filter collection - Either Uniformed Mode or Non Uniformed Mode
			model.filter.reportParameters = [];
			if (model.unifiedElementMap) {
				angular.forEach(model.filter.accountFiltersGrid, function (acctF) {
					if (acctF.fromValue && acctF.fromValue.length > 0) {
						model.filter.reportParameters.push(acctF);
					}
				});
			} else {
				let typeObj = { Mask: '', ElementMap: '' };

				angular.forEach(model.filter.accountFiltersType, function (acctF) {
					typeObj = acctF.type;

					angular.forEach(acctF.queries, function (query) {
						if (query.AccountTypeId > 0 && query.ElementIndex && query.QueryOption && query.Value) {
							let paramModel = {
								element: '',
								maxLength: 0,
								maxValue: 0,
								fromValue: 0,
								toValue: 0,
								accountTypeId: 0,
								startIndex: 0,
								queryOption: '',
							};

							let elements = typeObj.ElementMap.split('.');
							let lengths = typeObj.Mask.split('.');
							let objElement = elements[parseInt(query.ElementIndex)];
							let objMask = lengths[parseInt(query.ElementIndex)];

							paramModel.accountTypeId = parseInt(query.AccountTypeId);
							paramModel.queryOption = query.QueryOption;
							paramModel.fromValue = parseInt(query.Value);
							paramModel.maxLength = objMask.length;
							paramModel.startIndex = 0;

							let indexCount = 1;
							for (let mIdx = 0; mIdx < parseInt(query.ElementIndex); mIdx++) {
								indexCount += lengths[mIdx].length;
							}

							paramModel.startIndex = indexCount;
							model.filter.reportParameters.push(paramModel);
						}
					});
				});
			}

			var report = {
				FiscalYear: model.filter.fiscalYear.FiscalYear || 0,
				FiscalMonthFrom: model.filter.fiscalMonthFrom | 0,
				FiscalMonthTo: model.filter.fiscalMonthTo | 0,
				IsNutrition: model.isNutrition,
				ThirteenthMonth: model.filter.thirteenthMonth,
				DisplayBegMonthBalance: model.filter.displayBegMonthBalance,
				DisplayFundSummary: model.filter.displayFundSummary,
				ExcludeZeroBalanceAccounts: model.filter.excludeZeroBalanceAccounts,
				ExcludeZeroBalanceAccountsInactive: model.filter.excludeZeroBalanceAccountsInactive,
				SortElement: model.filter.sortElement || '-1',
				FundsCol: model.filter.fundsSelected,
				ElementRangeModelCol: model.filter.reportParameters,
			};

			reportHelper.getReport($scope, '/api/fundreports/trialbalancereport', report, 'TrialBalanceReport.pdf');
		}

		function exportExcel(model) {
			if (!validateReportParams(model)) {
				dialogHelper.openMessageBox('Trial Balance Report Error!', '', model.validationErrors, 'Warning');
				return false;
			}

			$scope.isReportFinished = false;
			model.message = BUSY_MESSAGE.GeneratingExcelFile;
			$scope.loadingPromise = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			// get selected funds
			model.filter.fundsSelected = [];
			if (model.fundsCheckAll === true) {
				model.filter.fundsSelected.push({ Id: 0, Description: 'All' });
			} else {
				let arrFunds = [model.fundsLeft, model.fundsMiddle, model.fundsRight];
				angular.forEach(arrFunds, function (funds) {
					angular.forEach(funds, function (obj) {
						if (obj.Selected === true) {
							let obj2 = { Id: obj.Id, Description: obj.Description };
							model.filter.fundsSelected.push(obj2);
						}
					});
				});
			}

			// Build Account Filter collection - Either Uniformed Mode or Non Uniformed Mode
			model.filter.reportParameters = [];
			if (model.unifiedElementMap) {
				angular.forEach(model.filter.accountFiltersGrid, function (acctF) {
					if (acctF.fromValue && acctF.fromValue.length > 0) {
						model.filter.reportParameters.push(acctF);
					}
				});
			} else {
				let typeObj = { Mask: '', ElementMap: '' };

				angular.forEach(model.filter.accountFiltersType, function (acctF) {
					typeObj = acctF.type;

					angular.forEach(acctF.queries, function (query) {
						if (query.AccountTypeId > 0 && query.ElementIndex && query.QueryOption && query.Value) {
							let paramModel = {
								element: '',
								maxLength: 0,
								maxValue: 0,
								fromValue: 0,
								toValue: 0,
								accountTypeId: 0,
								startIndex: 0,
								queryOption: '',
							};

							let elements = typeObj.ElementMap.split('.');
							let lengths = typeObj.Mask.split('.');
							let objElement = elements[parseInt(query.ElementIndex)];
							let objMask = lengths[parseInt(query.ElementIndex)];

							paramModel.accountTypeId = parseInt(query.AccountTypeId);
							paramModel.queryOption = query.QueryOption;
							paramModel.fromValue = parseInt(query.Value);
							paramModel.maxLength = objMask.length;
							paramModel.startIndex = 0;

							let indexCount = 1;
							for (let mIdx = 0; mIdx < parseInt(query.ElementIndex); mIdx++) {
								indexCount += lengths[mIdx].length;
							}

							paramModel.startIndex = indexCount;
							model.filter.reportParameters.push(paramModel);
						}
					});
				});
			}

			var report = {
				FiscalYear: model.filter.fiscalYear.FiscalYear || 0,
				FiscalMonthFrom: model.filter.fiscalMonthFrom | 0,
				FiscalMonthTo: model.filter.fiscalMonthTo | 0,
				IsNutrition: model.isNutrition,
				ThirteenthMonth: model.filter.thirteenthMonth,
				DisplayBegMonthBalance: model.filter.displayBegMonthBalance,
				DisplayFundSummary: model.filter.displayFundSummary,
				ExcludeZeroBalanceAccounts: model.filter.excludeZeroBalanceAccounts,
				ExcludeZeroBalanceAccountsInactive: model.filter.excludeZeroBalanceAccountsInactive,
				SortElement: model.filter.sortElement || '-1',
				FundsCol: model.filter.fundsSelected,
				ElementRangeModelCol: model.filter.reportParameters,
			};

			reportHelper.getExcel($scope, '/api/fundreports/trialbalanceexcel', report, 'TrialBalance.xlsx');
		}

		function fundSelectChange(model) {
			var leftIsSelected = _.every(model.fundsLeft, function (obj) {
				return obj.Selected === true;
			});

			var middleIsSelected = _.every(model.fundsMiddle, function (obj) {
				return obj.Selected === true;
			});

			var rightIsSelected = _.every(model.fundsRight, function (obj) {
				return obj.Selected === true;
			});

			model.fundsCheckAll = leftIsSelected === true && middleIsSelected === true && rightIsSelected === true;
		}

		function fundCheckAllChange(model) {
			angular.forEach(model.fundsLeft, function (f) {
				f.Selected = model.fundsCheckAll;
			});

			angular.forEach(model.fundsMiddle, function (f) {
				f.Selected = model.fundsCheckAll;
			});

			angular.forEach(model.fundsRight, function (f) {
				f.Selected = model.fundsCheckAll;
			});
		}

		function LoadAccountStructures(model) {
			return accountStructureService.getStructure().then(_.partial(finishLoadingStructure, model));

			function finishLoadingStructure(model, response) {
				model.unifiedElementMap = response.data.accountStructure.UnifiedElementMap;
				model.unifiedAccountMask = response.data.accountStructure.UnifiedAccountMask;
				model.unifiedFundElementIndex = response.data.accountStructure.UnifiedElementFundIndex;

				var arrElements = [];

				if (response.data.accountStructure.UnifiedElementMap !== null) {
					//model.elements = response.data.accountStructure.UnifiedElementMap.split('.');
					arrElements = response.data.accountStructure.UnifiedElementMap.split('.');
				} else {
					let assetElements = response.data.accountStructure.AssetElementMap.split('.');
					let liabilityElements = response.data.accountStructure.LiabilityElementMap.split('.');
					let reserveElements = response.data.accountStructure.ReserveElementMap.split('.');
					let revenueElements = response.data.accountStructure.RevenueElementMap.split('.');
					let expenseElements = response.data.accountStructure.ExpenseElementMap.split('.');

					arrElements = _.union(assetElements, liabilityElements, reserveElements, revenueElements, expenseElements);
				}

				// Build Elements
				angular.forEach(arrElements, function (e) {
					model.elements.push({ Id: e, Description: e });
				});
				model.elements.unshift({ Id: '-1', Description: '' });

				return angular.noop;
			}
		}

		function LoadFiscalYears(model) {
			$scope.loadingPromise = unitService.getFiscalYearsWithDates().then(_.partial(finishLoadingYears, model));

			function finishLoadingYears(model, response) {
				model.fiscalYears = response.data.fiscalYears;
				_.find(model.fiscalYears, function (yObj) {
					if (yObj.CurrentFY === yObj.FiscalYear) {
						model.filter.fiscalYear = yObj;
					}
				});

				return angular.noop;
			}
		}

		function LoadFunds(model) {
			return accountStructureService.getFunds().then(_.partial(finishLoadingFunds, model));

			function finishLoadingFunds(model, response) {
				var arrFunds = response.data.funds;

				var colSize = 3;
				if (arrFunds.length === 0) {
					return angular.noop;
				} else {
					var partialCol = arrFunds.length % 3 > 0 ? 1 : 0;
					colSize = parseInt(arrFunds.length / 3) + partialCol;
				}

				angular.forEach(arrFunds, function (f) {
					var obj = { Id: f, Description: f, Selected: true };
					if (model.fundsLeft.length < colSize) {
						model.fundsLeft.push(obj);
					} else if (model.fundsMiddle.length < colSize) {
						model.fundsMiddle.push(obj);
					} else if (model.fundsRight.length < colSize) {
						model.fundsRight.push(obj);
					}
				});

				return angular.noop;
			}
		}

		function LoadFiscalMonths(model) {
			$scope.loadingPromise = unitService.getFiscalMonths().then(_.partial(finishLoadingMonths, model));

			function finishLoadingMonths(model, response) {
				var arrMonths = response.data.fiscalMonths;
				angular.forEach(arrMonths, function (m) {
					var obj = { Id: 0, Description: m };
					switch (m) {
						case 'January':
							obj.Id = 1;
							break;
						case 'February':
							obj.Id = 2;
							break;
						case 'March':
							obj.Id = 3;
							break;
						case 'April':
							obj.Id = 4;
							break;
						case 'May':
							obj.Id = 5;
							break;
						case 'June':
							obj.Id = 6;
							break;
						case 'July':
							obj.Id = 7;
							break;
						case 'August':
							obj.Id = 8;
							break;
						case 'September':
							obj.Id = 9;
							break;
						case 'October':
							obj.Id = 10;
							break;
						case 'November':
							obj.Id = 11;
							break;
						case 'December':
							obj.Id = 12;
							break;
					}
					model.fiscalMonths.push(obj);
				});
				//model.fiscalMonths.unshift({ Id: "0", Description: "" });

				model.filter.fiscalMonthFrom = parseInt(moment().format('MM'));
				model.filter.fiscalMonthTo = parseInt(moment().format('MM'));

				return angular.noop;
			}
		}

		function manageZeroBalanceCheckBoxes(model, isDefault) {
			if (isDefault === true) {
				model.filter.excludeZeroBalanceAccountsInactive = false;
			} else {
				model.filter.excludeZeroBalanceAccounts = false;
			}
		}

		return angular.extend(model, {
			openReport: _.partial(openReport, model),
			exportExcel: _.partial(exportExcel, model),
			fundSelectChange: _.partial(fundSelectChange, model),
			fundCheckAllChange: _.partial(fundCheckAllChange, model),
			LoadAccountStructures: _.partial(LoadAccountStructures, model),
			LoadFiscalYears: _.partial(LoadFiscalYears, model),
			LoadFunds: _.partial(LoadFunds, model),
			LoadFiscalMonths: _.partial(LoadFiscalMonths, model),
			manageZeroBalanceCheckBoxes: _.partial(manageZeroBalanceCheckBoxes, model),
		});
	}
}
